export default {
  // List of pages where Footer is not rendered
  ignorePages: [
    'eticket', 'invite'
  ],
}